import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TaxService from '../../../Services/TaxService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. TaxComponent.showEditFunction always passes a fully-hydrated
// item (crudType Create or Update, with TaxesPaidByOptions pre-resolved before the wizard
// opens), so this is never invoked, but it keeps the windowDescription contract satisfied.
class TaxEditItem {}

export default class TaxWindowDescription {
  static titleForCreate = 'Add Tax';
  static titleForEdit = 'Edit Tax';
  static itemType = TaxEditItem;
  static finishButtonLabel = 'Save Tax';
  static messageOnSuccess = 'Tax has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: TaxesPaidByOptions is a host-injected
  // convenience for the Select field and was never part of the posted payload, so it's
  // stripped here before handing off to TaxService.PutTax. MUST return the promise
  // (wizard contract).
  static serviceFunction = (edited) => {
    const { TaxesPaidByOptions, ...rest } = edited;
    return TaxService.PutTax(rest);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ItemCode',
          label: 'Item Code',
          className: 'col-4',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'Rate',
          label: 'Rate (%)',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldMinZeroMaxOneHundred,
        },
        {
          fieldName: 'ThirdPartyName',
          label: 'Third Party Name',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'TaxesPaidBy',
          label: 'Taxes Paid By',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: (item) => item.TaxesPaidByOptions || [],
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ApplyToAssignmentFees',
          label: 'Apply To Assignment Fees',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ApplyToAssignmentReimbursements',
          label: 'Apply To Assignment Reimbursements',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ApplyToLineItemFees',
          label: 'Apply To Line Item Fees',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ApplyToLineItemReimbursements',
          label: 'Apply To Line Item Reimbursements',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ApplyToFeePrepayments',
          label: 'Apply To Fee Prepayments',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ApplyToReimbursementPrepayments',
          label: 'Apply To Reimbursement Prepayments',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Inactive',
          label: 'Inactive',
          className: 'col-4',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
